// Local response logic for Yumway AI Assistant

export const WEBSITE_DETAILS = {
  company_name: 'Yumway Food',
  website: 'yumwayfood.com',
  corporate_office: 'C-8/2 basement and Ground floor, Vasant Vihar near C block, Community Center New Delhi - 110057, India',
  factory_address: 'Newryan Global Private Limited, Plot No. 74-75, AKVN, Growth Center, Malanpur, Industrial Area, Bhind-477001, Madhya Pradesh, India',
  phone: '(+91) 9873578910',
  email: 'support@icedreamglobal.com',
  hours: '9:00 AM - 6:00 PM (Monday to Friday)',
  google_map_office: 'https://maps.google.com/?q=C-8/2+basement+and+Ground+floor+Vasant+Vihar+near+C+block+Community+Center+New+Delhi+110057',
  google_map_factory: 'https://maps.google.com/?q=Newryan+Global+Private+Limited+Plot+No.+74-75+AKVN+Growth+Center+Malanpur+Bhind',
};

export const PAGE_LINKS = [
  { title: 'Home', href: '/' },
  { title: 'Products', href: '/product' },
  { title: 'French Fries', href: '/frenchfries' },
  { title: 'Value Added Products', href: '/ourspecialty' },
  { title: 'Potato Flakes', href: '/potatoflakesandmashed' },
  { title: 'About Us', href: '/about' },
  { title: 'Exports', href: '/exports' },
  { title: 'Quality', href: '/quality' },
  { title: 'Contact Us', href: '/contactus' },
  { title: 'Blog', href: '/blog' },
  { title: 'Privacy Policy', href: '/privacypolicy' },
  { title: 'Terms & Conditions', href: '/termsandCondition' }
];

export const PRODUCT_DETAILS = {
  frenchfries: {
    title: 'French Fries',
    summary: 'Crispy premium french fries made from high-quality potatoes.',
    cuts: '6-11 mm',
    sizes: '2.5 kg | 1 kg | Private Label',
    cooking: ['Deep fry 170-180°C for 2.5-3.5 mins', 'Air fry 180°C for 10-12 mins', 'Bake 200°C for 12-15 mins'],
    page: '/frenchfries'
  },
  potatoFlakes: {
    title: 'Potato Flakes & Mashed',
    summary: 'Instant potato flakes and mashed potato products for easy preparation and consistent quality.',
    page: '/potatoflakesandmashed'
  },
  valueAdded: {
    title: 'Value Added Products',
    summary: 'Ready-to-cook potato specialties including burger patties, hash browns, herb & chilli patties, aloo tikki and wedges.',
    page: '/ourspecialty'
  },

};

export const SOCIAL_MEDIA = {
  facebook: 'https://www.facebook.com/share/yhbpDtnYReppzRBs/?mibextid=qi2Omg',
  instagram: 'https://www.instagram.com/icedreamglobal?igsh=bjU1am1mdTZ3bHNt',
  linkedin: 'https://www.linkedin.com/company/icedream-global/'
};

export const KEYWORDS = {
  GENERAL_KEYWORDS: {
    greeting: ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening', 'greetings']
  },
  RESTRICTED_KEYWORDS: ['medical', 'health', 'doctor', 'medication', 'prescription', 'disease', 'virus', 'covid'],
  STOP_WORDS: ['the', 'is', 'at', 'which', 'on', 'a', 'an', 'and', 'or', 'but', 'if', 'in', 'for', 'of', 'to', 'with', 'by', 'from', 'as', 'be', 'are', 'was', 'were', 'been', 'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would', 'could', 'should', 'may', 'might', 'must', 'can', 'that', 'this', 'these', 'those', 'i', 'you', 'we', 'he', 'she', 'it', 'they', 'what', 'when', 'where', 'why', 'how'],
  PRODUCT_KEYWORDS: {
    potatoes: ['potato', 'potatoes', 'frozen potato', 'processed potato', 'root vegetable'],
    frenchFries: ['french fries', 'fries', 'straight cut', 'shoestring'],
    potatoFlakes: ['potato flakes', 'mashed', 'instant mash', 'instant potato'],
    valueAdded: ['value added', 'burger patty', 'hash brown', 'aloo tikki', 'potato wedges', 'specialty products']
  },
  SERVICE_KEYWORDS: {
    export: ['export', 'exports', 'international', 'global', 'overseas', 'shipping'],
    quality: ['quality', 'standard', 'standards', 'certification', 'certifications', 'haccp', 'iso', 'test', 'testing', 'assurance'],
    contact: ['contact', 'email', 'phone', 'call', 'address', 'office', 'factory', 'location', 'map', 'reach'],
    infrastructure: ['infrastructure', 'facility', 'factory', 'plant', 'equipment', 'processing'],
    blog: ['blog', 'news', 'article', 'update'],
    policy: ['privacy', 'policy'],
    terms: ['terms', 'conditions', 'agreement', 'legal'],
    gallery: ['gallery', 'photo', 'photos', 'images', 'media'],
    social: ['social', 'facebook', 'twitter', 'instagram', 'linkedin']
  }
};

function keywordMatch(question, phrases) {
  return phrases.some(word => question.includes(word));
}

function getAddressIntent(question) {
  const office = keywordMatch(question, ['office address', 'corporate office', 'registered office', 'office location', 'office']);
  const factory = keywordMatch(question, ['factory address', 'factory location', 'facility', 'plant', 'factory']);
  const address = keywordMatch(question, ['address', 'location', 'map', 'site']);

  if (office && !factory) return 'officeAddress';
  if (factory && !office) return 'factoryAddress';
  if (address) return 'address';
  return null;
}

function detectIntent(question) {
  const lowerQuestion = question.toLowerCase();
  const addressIntent = getAddressIntent(lowerQuestion);
  if (addressIntent) return addressIntent;

  if (KEYWORDS.GENERAL_KEYWORDS && keywordMatch(lowerQuestion, KEYWORDS.GENERAL_KEYWORDS.greeting)) {
    return 'greeting';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.policy)) {
    return 'privacy';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.terms)) {
    return 'terms';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.blog)) {
    return 'blog';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.social)) {
    return 'social';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.gallery)) {
    return 'gallery';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.export)) {
    return 'export';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.quality)) {
    return 'quality';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.infrastructure)) {
    return 'infrastructure';
  }

  if (keywordMatch(lowerQuestion, KEYWORDS.SERVICE_KEYWORDS.contact)) {
    return 'contact';
  }

  if (lowerQuestion.includes('about') || lowerQuestion.includes('who are') || lowerQuestion.includes('company')) {
    return 'about';
  }

  if (lowerQuestion.includes('french fries') || lowerQuestion.includes('fries')) {
    return 'frenchfries';
  }

  if (lowerQuestion.includes('potato flakes') || lowerQuestion.includes('mashed')) {
    return 'potatoFlakes';
  }

  if (lowerQuestion.includes('value added') || lowerQuestion.includes('hash brown') || lowerQuestion.includes('aloo tikki') || lowerQuestion.includes('burger patty') || lowerQuestion.includes('potato wedges')) {
    return 'valueAdded';
  }

  if (lowerQuestion.includes('product') || lowerQuestion.includes('potato')) {
    return 'products';
  }

  return 'general';
}

export function getLocalResponse(question) {
  if (!question || question.trim().length < 2) {
    return {
      answer: 'Please ask a question about our products, export services, quality standards, or company contacts. I can help you find the right page and product details.',
      links: [
        { title: 'Browse Products', href: '/product' },
        { title: 'Contact Us', href: '/contactus' }
      ]
    };
  }

  const intent = detectIntent(question);

  switch (intent) {
    case 'greeting':
      return getGreetingResponse();
    case 'about':
      return getAboutResponse();
    case 'products':
      return getProductResponse(question);
    case 'frenchfries':
      return getFrenchFriesResponse();
    case 'potatoFlakes':
      return getPotatoFlakesResponse();
    case 'valueAdded':
      return getValueAddedResponse();
    case 'export':
      return getExportResponse();
    case 'quality':
      return getQualityResponse();
    case 'contact':
      return getContactResponse();
    case 'address':
      return getAllAddressesResponse();
    case 'officeAddress':
      return getOfficeAddressResponse();
    case 'factoryAddress':
      return getFactoryAddressResponse();
    case 'infrastructure':
      return getInfrastructureResponse();
    case 'blog':
      return getBlogResponse();
    case 'privacy':
      return getPrivacyResponse();
    case 'terms':
      return getTermsResponse();
    case 'social':
      return getSocialResponse();
    case 'gallery':
      return getGalleryResponse();
    default:
      return getGeneralResponse();
  }
}

function getGreetingResponse() {
  return {
    answer: 'Hello! I can quickly guide you through Yumway products, export details, quality standards, or contact information. What would you like to explore?',
    links: [
      { title: 'Browse Products', href: '/product' },
      { title: 'Contact Us', href: '/contactus' }
    ]
  };
}

function getAboutResponse() {
  return {
    answer: 'Yumway Food specializes in premium frozen food products with a focus on French Fries, Value Added Products, and Potato Flakes. We maintain export-ready quality standards and strong facility controls.',
    links: [
      { title: 'About Us', href: '/about' },
      { title: 'Quality', href: '/quality' },
      { title: 'Products', href: '/product' }
    ]
  };
}

function getProductResponse(question) {
  const lower = question.toLowerCase();

  if (lower.includes('french fries') || lower.includes('fries')) {
    return getFrenchFriesResponse();
  }
  if (lower.includes('potato flakes') || lower.includes('mashed')) {
    return getPotatoFlakesResponse();
  }
  if (lower.includes('value added') || lower.includes('hash brown') || lower.includes('burger patty') || lower.includes('potato wedges')) {
    return getValueAddedResponse();
  }

  return {
    answer: 'Explore our main product pages: French Fries, Value Added Products, and Potato Flakes for Yumway food offerings.',
    links: [
      { title: 'Products', href: '/product' },
      { title: 'French Fries', href: '/frenchfries' },
      { title: 'Value Added Products', href: '/ourspecialty' },
      { title: 'Potato Flakes', href: '/potatoflakesandmashed' }
    ]
  };
}

function getFrozenPotatoesResponse() {
  return {
    answer: 'Yumway frozen potatoes are processed and stored under strict temperature control. They are ideal for restaurants and retailers who need reliable frozen potato products.',
    links: [
      { title: 'Frozen Potatoes', href: '/frozenpotatoes' },
      { title: 'Potatoes', href: '/potatoes' }
    ]
  };
}

function getFrenchFriesResponse() {
  const details = PRODUCT_DETAILS.frenchfries;
  return {
    answer: `We offer different types of French Fries in various cuts and packaging options. To explore our full range and product details, kindly visit the link below.`,
    links: [
      { title: details.title, href: details.page },
      { title: 'All Products', href: '/product' }
    ]
  };
}

function getPotatoFlakesResponse() {
  return {
    answer: 'Potato flakes and mashed potato are instant products that rehydrate quickly. They are convenient for food service, retail, and value-added kitchen applications.',
    links: [
      { title: 'Potato Flakes & Mashed', href: '/potatoflakesandmashed' },
    ]
  };
}

function getValueAddedResponse() {
  return {
    answer: 'Value-added products include potato burger patties, hash browns, herb & chilli burger patties, aloo tikki, and wedges. These are ready-to-cook, frozen specialties for retail and food service.',
    links: [
      { title: 'Value Added Products', href: '/ourspecialty' },
    ]
  };
}

function getPotatoProcessingResponse() {
  return {
    answer: 'Potato processing includes cleaning, cutting, blanching, and freezing to deliver consistent potato products for french fries, flakes, and value-added lines.',
    links: [
      // { title: 'Potato Processing', href: '/potatoprocessing' },
      { title: 'Potatoes', href: '/potatoes' }
    ]
  };
}

function getExportResponse() {
  return {
    answer: 'Yumway exports premium frozen and processed food products worldwide. We focus on HACCP and ISO 22000:2018 quality compliance for international shipping.',
    links: [
      { title: 'Exports', href: '/exports' }
    ]
  };
}

function getQualityResponse() {
  return {
    answer: 'Yumway follows rigorous quality controls, HACCP certification, ISO 22000:2018 compliance, cold-chain management, and third-party testing across all food products.',
    links: [
      { title: 'Quality', href: '/quality' },
    ]
  };
}

function getContactResponse() {
  return {
    answer: `Email: ${WEBSITE_DETAILS.email}. Phone: ${WEBSITE_DETAILS.phone}. For all inquiries, visit our contact page.`,
    links: [
      { title: 'Contact Us', href: '/contactus' }
    ]
  };
}

function getAllAddressesResponse() {
  return {
    answer: `Corporate & Registered Office: ${WEBSITE_DETAILS.corporate_office}\n\nFactory Address: ${WEBSITE_DETAILS.factory_address}`,
    links: [
      { title: 'Contact Us', href: '/contactus' }
    ]
  };
}

function getOfficeAddressResponse() {
  return {
    answer: `Corporate & Registered Office: ${WEBSITE_DETAILS.corporate_office}`,
    links: [
      { title: 'Office Location', href: WEBSITE_DETAILS.google_map_office }
    ]
  };
}

function getFactoryAddressResponse() {
  return {
    answer: `Factory Address: ${WEBSITE_DETAILS.factory_address}`,
    links: [
      { title: 'Factory Location', href: WEBSITE_DETAILS.google_map_factory }
    ]
  };
}



function getInfrastructureResponse() {
  return {
    answer: 'Our infrastructure includes modern processing lines, cold storage facilities, and quality testing labs for food manufacturing and export-ready products.',
    links: [
      { title: 'Quality', href: '/about' }
    ]
  };
}

function getBlogResponse() {
  return {
    answer: 'Visit the blog for news, updates, and industry articles about Yumway and our products.',
    links: [
      { title: 'Blogs', href: 'https://yumwayfood.com/blogs/' }
    ]
  };
}

function getPrivacyResponse() {
  return {
    answer: 'Read how Yumway protects your personal information and data usage practices on our privacy policy page.',
    links: [
      { title: 'Privacy Policy', href: '/privacypolicy' }
    ]
  };
}

function getTermsResponse() {
  return {
    answer: 'Review the terms and conditions that govern use of this website and our services on the terms page.',
    links: [
      { title: 'Terms & Conditions', href: '/termsandCondition' }
    ]
  };
}

function getSocialResponse() {
  return {
    answer: 'Follow Yumway on social media for product updates and company news. Use the links below to connect with us.',
    links: [
      { title: 'Facebook', href: SOCIAL_MEDIA.facebook },
      { title: 'Instagram', href: SOCIAL_MEDIA.instagram },
      { title: 'LinkedIn', href: SOCIAL_MEDIA.linkedin }
    ]
  };
}

function getGalleryResponse() {
  return {
    answer: 'See our gallery and product photos on the homepage where we showcase Yumway facilities, product lines, and export-ready packs.',
    links: [
      { title: 'Home Page Gallery', href: '/' }]
  };
}

function getGeneralResponse() {
  return {
    answer: 'I could not find exactly what you need. Please contact us for more discussion and support.',
    links: [
      { title: 'Contact Us', href: '/contactus' }
    ]
  };
}
